export default __webpack_public_path__ + "/dist/images/yourdata-inactive.dc224e3cfa706d4d86326f275e2947e5.svg";